function deepProxy(target, o, e) {
	return target instanceof Object
		? (target = new Proxy(target, {
			get: (t, p) => deepProxy(
				e ? t[p] : o.get(t, p),
				e ? { set: (t, p, v) => t[p] = v } : o,
				v => target[p] = v
			),
			set: (t, p, v) => {
				o.set(t, p, v);
				e && e(t, p, v);
				return true;
			}
		}))
		: target;
}

export default {
	install(Vue) {

		/**
		 * 封装Storage
		 */
		Object.assign(Vue.prototype, Object.entries({
			$local: localStorage,
			$session: sessionStorage
		}).reduce((p, [k, v]) => {
			return Vue.ext[k.replace(/^\$/gm, '')] = p[k] = deepProxy(v, {
				get(target, prop) {
					let $ = `$(${prop})`;
					if ($ in target) {
						return JSON.parse(target[$]);
					} else {
						return target[prop];
					}
				},
				set(target, prop, value) {
					if (prop in target) {
						target[prop] = value;
					} else {
						target[`$(${prop})`] = JSON.stringify(value);
					}
				}
			}), p;
		}, {}));

		/**
		 * 存储
		 */
		Vue.prototype.$store = {};

	}
}



// WEBPACK FOOTER //
// ./src/vue-ext/script/store.js